import { gsap } from "@gsap";
/**
 * Layout: Hero - Vacature detail
 * Slug: hero_vacature_detail
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.hero_vacature_detail-layout');

	layouts.forEach((layout) => {
		gsap.from(layout.querySelector(".side-col"), {
			xPercent: -5,
			opacity: 0
		});
	});
});
